import React from 'react';
import { Link } from 'react-router-dom';
import { projectService } from '../../services/projectService';
import { getMediaUrl } from '../../services/api';

export default class ProjectThree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            loading: true
        };
    }

    async componentDidMount() {
        try {
            const res = await projectService.getFeaturedProjects();
            if (res.success && Array.isArray(res.data)) {
                this.setState({ projects: res.data, loading: false }, () => {
                    this.initCarousel();
                });
            } else {
                this.fallbackProjects();
            }
        } catch (error) {
            console.error('Failed to load featured projects:', error);
            this.fallbackProjects();
        }
    }

    fallbackProjects() { this.setState({ projects: [], loading: false }); }

    initCarousel() {
        const $ = window.$;
        if ($ && $(".project-three__carousel").length) {
            $(".project-three__carousel").trigger('destroy.owl.carousel');
            $(".project-three__carousel").owlCarousel({
                loop: true,
                margin: 10,
                nav: false,
                smartSpeed: 500,
                autoHeight: false,
                autoplay: true,
                dots: false,
                autoplayTimeout: 6000,
                navText: [
                    '<i className="fa fa-angle-double-left" aria-hidden="true"></i>',
                    '<i className="fa fa-angle-double-right" aria-hidden="true"></i>',
                ],
                responsive: {
                    0: { items: 1 },
                    600: { items: 1 },
                    750: { items: 2 },
                    1100: { items: 3 },
                    1350: { items: 4 },
                },
            });
        }

        if ($ && $(".img-popup").length) {
            var groups = {};
            $(".img-popup").each(function () {
                var id = parseInt($(this).attr("data-group"), 10);
                if (!groups[id]) {
                    groups[id] = [];
                }
                groups[id].push(this);
            });

            $.each(groups, function () {
                $(this).magnificPopup({
                    type: "image",
                    closeOnContentClick: true,
                    closeBtnInside: false,
                    gallery: {
                        enabled: true,
                    },
                });
            });
        }
    }

    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';
        const { projects } = this.state;

        return (
            <>
                <section className="project-three">
                    <div className="container-fluid">
                        <div className="sec-title text-center">
                            <div className="sec-title__tagline">
                                <span className="left"></span>
                                <h6>LATEST PROJECT</h6> <span className="right"></span>
                            </div>
                            <h2 className="sec-title__title">Our latest completed and <br /> running projects.</h2>
                        </div>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="project-three__carousel owl-carousel owl-theme">
                                    {projects.map((project, index) => {
                                        const imgUrl = getMediaUrl(project.image);

                                        return (
                                            <div className="project-three__single" key={project.id || index}>
                                                <div className="project-three__single-img">
                                                    <img src={imgUrl} alt={project.title} />
                                                    <div className="icon-box">
                                                        <a className="img-popup" href={imgUrl}>
                                                            <span className="icon-plus-sign"></span>
                                                        </a>
                                                    </div>
                                                    <div className="content-box">
                                                        <p>{project.title}</p>
                                                        <h3><Link to={process.env.PUBLIC_URL + `/projects`}>View All Projects</Link></h3>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="col-xl-12">
                                <div className="project-three-more-project-btn text-center">
                                    <div className="service-btn d-flex align-items-center justify-content-center">
                                        <Link className='btn border p-3 text-white w-auto' id='service-btn' style={{ transition: 'all 0.3s ease' }}
                                            to={publicUrl + "projects"}>All Projects</Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </>
        );
    }
}
